'use client'

import { Button } from '@wartek-id/button'
import {
  Dialog,
  DialogCloseButton,
  DialogContent,
  DialogFooter,
  DialogOverlay,
} from '@wartek-id/dialog'
import { Separator } from '@wartek-id/separator'
import { Text } from '@wartek-id/text'

import { MAP_JENIS_DOKUMEN_ITEM_BY_VALUE } from '@/apis/data/jenisDocumentMapping'
import { Publication } from '@/apis/types'

import { PdfFrame } from '../../../components/PdfFrame'

export function PreviewDialog({
  onClose,
  show,
  previewItem,
  onDownload,
}: {
  previewItem?: Publication | null
  show: boolean
  onClose: () => void
  onDownload: (pub: Publication) => void
}) {
  return (
    <Dialog onClose={onClose} isOpen={show} size="md">
      <DialogOverlay />
      <DialogContent>
        <div className="flex flex-col gap-4 px-4 py-4">
          <div className="flex flex-wrap items-center gap-2">
            <Text color="subdued" data-testid={`txt-selected-year-desktop`}>
              {previewItem?.yearPeriod}
            </Text>
            <Separator
              style={{
                width: 1,
                height: 18,
              }}
            />
            <Text color="subdued" data-testid={`txt-selected-type-desktop`}>
              {MAP_JENIS_DOKUMEN_ITEM_BY_VALUE[previewItem?.type || '']?.LABEL}
            </Text>
          </div>

          <Text variant="heading-lg" data-testid={`txt-selected-title-desktop`}>
            {previewItem?.title}
          </Text>

          <Text data-testid={`txt-selected-desc-desktop`}>
            {previewItem?.description}
          </Text>

          <div>{previewItem?.url && <PdfFrame url={previewItem?.url} />}</div>
        </div>
        <DialogFooter>
          <Button
            fullWidth
            size="lg"
            as="a"
            href={previewItem?.url}
            onClick={() => {
              onDownload(previewItem as Publication)
            }}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="btn-download-desktop"
          >
            Unduh Publikasi
          </Button>
        </DialogFooter>
        <DialogCloseButton data-testid="btn-close-dialog" />
      </DialogContent>
    </Dialog>
  )
}
